import { delayed } from "./Delay.js";
/**
 *
 */
class DestroyOptions {
  constructor() {
    this.delay = 0;
  }
}

/**
 *
 */
const DefaultDestroyOptions = new DestroyOptions();

/**
 *
 * @param {*} scene
 * @param {*} runtime
 * @returns
 */
const destroy =
  (runtime) =>
  (obj, options = DefaultDestroyOptions) => {
    if (obj !== undefined && obj !== null) {
      const removeFromScene = () => {
        if (typeof obj.traverse === 'function') {
          obj.traverse(node => {
            // TODO: Improve this using type check
            if (node.code) {
              runtime.unregisterBehaviourNode(node);
            }
          });
        }
        obj.removeFromParent();        
      };

      if (options?.delay > 0) {
        delayed(removeFromScene, options?.delay);
      } else {
        removeFromScene();
      }
    } else {
      throw new Error('Invalid object to destroy');
    }
  };

export { destroy };
